import { Component, ElementRef, OnInit } from '@angular/core';

@Component({
  selector: 'uex-layout-sidebar-footer',
  templateUrl: './footer.component.html',
  host: {
    class: 'uex-layout-sidebar-footer'
  }
})

export class LayoutSidebarFooterComponent implements OnInit {

  constructor(
    public elementRef: ElementRef
  ) { }

  ngOnInit() { }
}
